/* eslint-disable max-lines */

import { DisplayMetadata } from '../types/Common';

interface AdvancedDisplayMetadata {
  [product: string]: {
    [node: string]: {
      [group: string]: DisplayMetadata[];
    };
  };
}

export const timeZoneData = {
  options: [
    'America/Argentina/Buenos_Aires',
    'Etc/GMT-1',
    'Africa/Abidjan',
    'Africa/Accra',
    'Africa/Addis_Ababa',
    'Africa/Algiers',
    'Africa/Asmara',
    'Africa/Asmera',
    'Africa/Bamako',
    'Africa/Bangui',
    'Africa/Banjul',
    'Africa/Bissau',
    'Africa/Blantyre',
    'Africa/Brazzaville',
    'Africa/Bujumbura',
    'Africa/Cairo',
    'Africa/Cape Verde',
    'Africa/Casablanca',
    'Africa/Ceuta',
    'Africa/Conakry',
    'Africa/Dakar',
    'Africa/Dar_es_Salaam',
    'Africa/Djibouti',
    'Africa/Douala',
    'Africa/El_Aaiun',
    'Africa/Freetown',
    'Africa/Gaborone',
    'Africa/Harare',
    'Africa/Johannesburg',
    'Africa/Juba',
    'Africa/Kampala',
    'Africa/Khartoum',
    'Africa/Kigali',
    'Africa/Kinshasa',
    'Africa/Lagos',
    'Africa/Libreville',
    'Africa/Lome',
    'Africa/Luanda',
    'Africa/Lubumbashi',
    'Africa/Lusaka',
    'Africa/Malabo',
    'Africa/Maputo',
    'Africa/Maseru',
    'Africa/Mbabane',
    'Africa/Mogadishu',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'Africa/Ndjamena',
    'Africa/Niamey',
    'Africa/Nouakchott',
    'Africa/Ouagadougou',
    'Africa/Porto-Novo',
    'Africa/Sao_Tome',
    'Africa/Seychelles',
    'Africa/Timbuktu',
    'Africa/Tripoli',
    'Africa/Tunis',
    'Africa/Windhoek',
    'America/Adak',
    'America/Amazon',
    'America/Anchorage',
    'America/Anguilla',
    'America/Antigua',
    'America/Araguaina',
    'America/Argentina/Catamarca',
    'America/Argentina/ComodRivadavia',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'America/Aruba',
    'America/Asuncion',
    'America/Atikokan',
    'America/Atka',
    'America/Bahia',
    'America/Baker Island',
    'America/Bahia_Banderas',
    'America/Barbados',
    'America/Belem',
    'America/Belize',
    'America/Blanc-Sablon',
    'America/Boa_Vista',
    'America/Bogota',
    'America/Boise',
    'America/Bolivia',
    'America/Brasilia',
    'America/Buenos_Aires',
    'America/Cambridge_Bay',
    'America/Campo_Grande',
    'America/Cancun',
    'America/Caracas',
    'America/Catamarca',
    'America/Cayenne',
    'America/Cayman',
    'America/Chicago',
    'America/Chihuahua',
    'America/Colombia Summer',
    'America/Colombia',
    'America/Coral_Harbour',
    'America/Cordoba',
    'America/Costa_Rica',
    'America/Creston',
    'America/Cuiaba',
    'America/Curacao',
    'America/Danmarkshavn',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Denver',
    'America/Detroit',
    'America/Dominica',
    'America/Edmonton',
    'America/Eirunepe',
    'America/El_Salvador',
    'America/Ensenada',
    'America/Ecuador',
    'America/Falkland Islands Standard',
    'America/Falkland Islands Summer',
    'America/Falkland Islands',
    'America/Fernando de Noronha',
    'America/Fort_Wayne',
    'America/Fortaleza',
    'America/Glace_Bay',
    'America/Godthab',
    'America/Goose_Bay',
    'America/Grand_Turk',
    'America/Grenada',
    'America/Guadeloupe',
    'America/Guatemala',
    'America/Guayaquil',
    'America/Guyana',
    'America/Halifax',
    'America/Havana',
    'America/Hawaii-Aleutian Daylight',
    'America/Hawaii-Aleutian Standard',
    'America/Hermosillo',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indianapolis',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Jamaica',
    'America/Jujuy',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Knox_IN',
    'America/Kralendijk',
    'America/La_Paz',
    'America/Lima',
    'America/Los_Angeles',
    'America/Louisville',
    'America/Lower_Princes',
    'America/Maceio',
    'America/Managua',
    'America/Manaus',
    'America/Marigot',
    'America/Martinique',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Mendoza',
    'America/Menominee',
    'America/Merida',
    'America/Metlakatla',
    'America/Mexico_City',
    'America/Miquelon',
    'America/Moncton',
    'America/Monterrey',
    'America/Montevideo',
    'America/Montreal',
    'America/Montserrat',
    'America/Nassau',
    'America/New_York',
    'America/Nipigon',
    'America/Nome',
    'America/Noronha',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Ojinaga',
    'America/Panama',
    'America/Pangnirtung',
    'America/Paraguay Summer',
    'America/Paraguay',
    'America/Paramaribo',
    'America/Peru',
    'America/Phoenix',
    'America/Port_of_Spain',
    'America/Port-au-Prince',
    'America/Porto_Acre',
    'America/Porto_Velho',
    'America/Puerto_Rico',
    'America/Rainy_River',
    'America/Rankin_Inlet',
    'America/Recife',
    'America/Regina',
    'America/Resolute',
    'America/Rio_Branco',
    'America/Rosario',
    'America/Saint Pierre and Miquelon Standard',
    'America/Santa_Isabel',
    'America/Santarem',
    'America/Santiago',
    'America/Santo_Domingo',
    'America/Sao_Paulo',
    'America/Scoresbysund',
    'America/Shiprock',
    'America/Sitka',
    'America/St_Barthelemy',
    'America/St_Johns',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/St_Thomas',
    'America/St_Vincent',
    'America/Suriname',
    'America/Swift_Current',
    'America/Tegucigalpa',
    'America/Thule',
    'America/Thunder_Bay',
    'America/Tijuana',
    'America/Toronto',
    'America/Tortola',
    'America/Uruguay Summer',
    'America/Uruguay Standard',
    'America/Vancouver',
    'America/Venezuelan Standard',
    'America/Virgin',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/Yakutat',
    'America/Yellowknife',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Macquarie',
    'Antarctica/Mawson',
    'Antarctica/McMurdo',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Showa Station',
    'Antarctica/South_Pole',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'Arctic/Longyearbyen',
    'Asia/Aden',
    'Asia/Afghanistan',
    'Asia/Almaty',
    'Asia/Amman',
    'Asia/Anadyr',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Armenia',
    'Asia/Ashgabat',
    'Asia/Ashkhabad',
    'Asia/Azerbaijan',
    'Asia/Baghdad',
    'Asia/Bahrain',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Beirut',
    'Asia/Bhutan',
    'Asia/Bishkek',
    'Asia/Brunei',
    'Asia/Calcutta',
    'Asia/Central Indonesia',
    'Asia/China Standard',
    'Asia/China',
    'Asia/Choibalsan',
    'Asia/Chongqing',
    'Asia/Chungking',
    'Asia/Colombo',
    'Asia/Dacca',
    'Asia/Damascus',
    'Asia/Dhaka',
    'Asia/Dili',
    'Asia/Dubai',
    "Asia/Dumont d'Urville",
    'Asia/Dushanbe',
    'Asia/Gaza',
    'Asia/Gulf Standard',
    'Asia/Harbin',
    'Asia/Hebron',
    'Asia/Ho_Chi_Minh',
    'Asia/Hong Kong',
    'Asia/Hovd',
    'Asia/Indochina',
    'Asia/Irkutsk',
    'Asia/Istanbul',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kashgar',
    'Asia/Kathmandu',
    'Asia/Katmandu',
    'Asia/Khandyga',
    'Asia/Khovd',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kyrgyzstan',
    'Asia/Kuching',
    'Asia/Kuwait',
    'Asia/Macao',
    'Asia/Macau',
    'Asia/Magadan',
    'Asia/Makassar',
    'Asia/Malaysia',
    'Asia/Malaysia Standard',
    'Asia/Manila',
    'Asia/Muscat',
    'Asia/Myanmar',
    'Asia/Nepal',
    'Asia/Nicosia',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Oral',
    'Asia/Pakistan Standard',
    'Asia/Philippine',
    'Asia/Phnom_Penh',
    'Asia/Pontianak',
    'Asia/Pyongyang',
    'Asia/Qatar',
    'Asia/Qyzylorda',
    'Asia/Rangoon',
    'Asia/Riyadh',
    'Asia/Saigon',
    'Asia/Sakhalin',
    'Asia/Samarkand',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/South Georgia and the South Sandwich Islands',
    'Asia/Sri Lanka',
    'Asia/Taipei',
    'Asia/Tajikistan',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Tel_Aviv',
    'Asia/Thailand Standard',
    'Asia/Thimbu',
    'Asia/Thimphu',
    'Asia/Timor Leste',
    'Asia/Tokyo',
    'Asia/Turkmenistan',
    'Asia/Ujung_Pandang',
    'Asia/Ulaanbaatar',
    'Asia/Ulan_Bator',
    'Asia/Urumqi',
    'Asia/Ust-Nera',
    'Asia/Uzbekistan',
    'Asia/Vientiane',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Atlantic/Azores',
    'Atlantic/Bermuda',
    'Atlantic/Canary',
    'Atlantic/Cape_Verde',
    'Atlantic/Faeroe',
    'Atlantic/Faroe',
    'Atlantic/Jan_Mayen',
    'Atlantic/Madeira',
    'Atlantic/Reykjavik',
    'Atlantic/South_Georgia',
    'Atlantic/St_Helena',
    'Atlantic/Stanley',
    'Australia/ACT',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Canberra',
    'Australia/Currie',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Heard and McDonald Islands',
    'Australia/Hobart',
    'Australia/LHI',
    'Australia/Lindeman',
    'Australia/Lord Howe Standard',
    'Australia/Lord Howe Summer',
    'Australia/Melbourne',
    'Australia/North',
    'Australia/NSW',
    'Australia/Perth',
    'Australia/Queensland',
    'Australia/South',
    'Australia/Sydney',
    'Australia/Tasmania',
    'Australia/Victoria',
    'Australia/West',
    'Australia/Yancowinna',
    'Brazil/Acre',
    'Brazil/DeNoronha',
    'Brazil/East',
    'Brazil/West',
    'Canada/Atlantic',
    'Canada/Central',
    'Canada/Eastern',
    'Canada/East-Saskatchewan',
    'Canada/Mountain',
    'Canada/Newfoundland',
    'Canada/Pacific',
    'Canada/Saskatchewan',
    'Canada/Yukon',
    'Caribbean/Eastern Caribbean',
    'Chile/Continental',
    'Chile/EasterIsland',
    'Cuba',
    'Egypt',
    'Eire',
    'Etc/GMT',
    'Etc/GMT+0',
    'Etc/UCT',
    'Etc/Universal',
    'Etc/UTC',
    'Etc/Zulu',
    'Europe/AIX specific equivalent of Central European',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Athens',
    'Europe/Belfast',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Bratislava',
    'Europe/British Summer',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Busingen',
    'Europe/Chisinau',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Gibraltar',
    'Europe/Guernsey',
    'Europe/Helsinki',
    "Europe/Heure AvancÃ©e d'Europe Centrale francised name for CEST",
    'Europe/Irish Standard',
    'Europe/Isle_of_Man',
    'Europe/Istanbul',
    'Europe/Jersey',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Lisbon',
    'Europe/Ljubljana',
    'Europe/London',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Malta',
    'Europe/Mariehamn',
    'Europe/Minsk',
    'Europe/Monaco',
    'Europe/Moscow',
    'Europe/Nicosia',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Podgorica',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/San_Marino',
    'Europe/Sarajevo',
    'Europe/Simferopol',
    'Europe/Skopje',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Tirane',
    'Europe/Tiraspol',
    'Europe/Uzhgorod',
    'Europe/Vaduz',
    'Europe/Vatican',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zagreb',
    'Europe/Zaporozhye',
    'Europe/Zurich',
    'GB',
    'GB-Eire',
    'GMT',
    'GMT+0',
    'GMT0',
    'GMT-0',
    'Greenwich',
    'Hongkong',
    'Iceland',
    'Indian/Antananarivo',
    'Indian/Chagos',
    'Indian/British Indian Ocean',
    'Indian/Christmas',
    'Indian/Cocos',
    'Indian/Comoro',
    'Indian/Indian Standard',
    'Indian/Kerguelen',
    'Indian/Mahe',
    'Indian/Maldives',
    'Indian/Mauritius',
    'Indian/Mayotte',
    'Indian/Reunion',
    'Iran',
    'Israel',
    'Jamaica',
    'Japan',
    'Kwajalein',
    'Libya',
    'Mexico/BajaNorte',
    'Mexico/BajaSur',
    'Mexico/General',
    'Navajo',
    'NZ',
    'NZ-CHAT',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Chamorro',
    'Pacific/Chatham',
    'Pacific/Chuuk',
    'Pacific/Clipperton',
    'Pacific/Cook Island',
    'Pacific/Easter Island Standard',
    'Pacific/Easter Island Summer',
    'Pacific/Efate',
    'Pacific/Enderbury',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Funafuti',
    'Pacific/Galapagos',
    'Pacific/Gambier',
    'Pacific/Gilbert Island',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Honolulu',
    'Pacific/Johnston',
    'Pacific/Kiritimati',
    'Pacific/Kosrae',
    'Pacific/Kwajalein',
    'Pacific/Line Islands',
    'Pacific/Majuro',
    'Pacific/Marquesas',
    'Pacific/Marshall Islands',
    'Pacific/Midway',
    'Pacific/Nauru',
    'Pacific/New Caledonia',
    'Pacific/New Zealand Daylight',
    'Pacific/New Zealand Standard',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Palau',
    'Pacific/Papua New Guinea',
    'Pacific/Pitcairn',
    'Pacific/Pohnpei',
    'Pacific/Ponape',
    'Pacific/Port_Moresby',
    'Pacific/Rarotonga',
    'Pacific/Saipan',
    'Pacific/Samoa',
    'Pacific/Solomon Islands',
    'Pacific/Tahiti',
    'Pacific/Tarawa',
    'Pacific/Tokelau',
    'Pacific/Tongatapu',
    'Pacific/Truk',
    'Pacific/Tuvalu',
    'Pacific/Vanuatu',
    'Pacific/Wake',
    'Pacific/Wallis',
    'Pacific/Yap',
    'Poland',
    'Portugal',
    'PRC',
    'ROC',
    'ROK',
    'Singapore',
    'Turkey',
    'UCT',
    'Universal/Universal Time Coordinated',
    'US/Alaska',
    'US/Aleutian',
    'US/Arizona',
    'US/Central',
    'US/Eastern',
    'US/East-Indiana',
    'US/Hawaii',
    'US/Indiana-Starke',
    'US/Michigan',
    'US/Mountain',
    'US/Pacific',
    'US/Samoa',
    'UTC',
    'W-SU',
    'Zulu'
  ].map(i => ({
    textLabel: i,
    value: i
  }))
};

export const advancedDisplayMetadata: AdvancedDisplayMetadata = {
  vrops: {
    remotecollector: {
      vropsDataDefault: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    cloudproxy: {
      vropsDataDefault: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    witness: {
      vropsDataDefault: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    master: {
      vrops_master_default_property: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useMasterIdentityManager',
          order: 1,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    data: {
      vropsDataDefault: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    replica: {
      vropsDataDefault: [
        {
          name: 'timeZone',
          order: 0,
          data: timeZoneData,
          validationRules: [],
          displayRules: []
        }
      ]
    }
  },
  vidm: {
    'vidm-connector': {
      vcenterInfra: [
        {
          name: 'vCenterHost',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    }
  },
  vra: {
    'vra-server-primary': {
      vra_7_0_0_0_vra_default_property: [
        {
          name: 'installInitialContent',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'enablePostgresDbSyncMode',
          order: 1,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'vrava-primary': {
      vra_8_0_0_password: [
        {
          name: 'rootPassword',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'vrava-secondary': {
      vra_8_0_0_password: [
        {
          name: 'rootPassword',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    db: {
      vraDb: [
        {
          name: 'useExistingDatabase',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsAuthentication',
          order: 1,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'databasePassword',
          order: 2,
          validationRules: [],
          displayRules: []
        }
      ],
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'iaas-manager-active': {
      iaasManager: [
        {
          name: 'managerServiceFailoverModeEnabled',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ],
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'iaas-web': {
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ],
      iaasweb: [
        {
          name: 'iaasSecurityPassphrase',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'iaas-dem-worker': {
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'iaas-manager-passive': {
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ],
      iaasManagerpassive: [
        {
          name: 'iaasSecurityPassphrase',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'proxy-agent-vsphere': {
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'iaas-dem-orchestrator': {
      windowsIaas: [
        {
          name: 'useIso',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useWindowsTemplate',
          order: 0,
          validationRules: [],
          displayRules: []
        },
        {
          name: 'useCustomSpec',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    }
  },
  vrbc: {
    'vrb-server': {
      vrb_default_property: [
        {
          name: 'isTelemetryEnable',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    },
    'vrb-collector': {
      vrbDefault: [
        {
          name: 'isTelemetryEnable',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    }
  },
  vrli: {
    'vrli-master': {
      vrli_default_property: [
        {
          name: 'useMasterIdentityManager',
          order: 0,
          validationRules: [],
          displayRules: []
        }
      ]
    }
  }
};
